'use client';
import { cn } from "@/lib/utils";
import { ReactNode } from "react";
import SubHeader from "../sub-header";

interface DefaultPageLayoutProps {
      children: ReactNode;
      title?: string;
      subtitle?: string;
      canGoBack?: boolean;
      actions?: ReactNode;
      className?: string;
      showBackButtonTitle?: boolean;
}

const DefaultPageLayout = ({ children, title, subtitle, canGoBack, actions, className, showBackButtonTitle }: DefaultPageLayoutProps) => {
      return <div className={cn("container mx-auto p-4 w-full", className)}>
            <div className="flex items-center justify-between mb-4">
                  <SubHeader title={title} subtitle={subtitle} canGoBack={canGoBack} showBackButtonTitle={showBackButtonTitle} />
                  {actions && actions}
            </div>
            {children}
      </div>
};

export default DefaultPageLayout;


